export const VIEWPORT_HEIGHT = '100vh';
